import React, { useEffect, useState, useRef, useCallback } from "react";
import nodata from "../../assets/img/no-data.svg";
import { Link } from "react-router-dom";
import { LevelIncomeElegible } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";

import Loader from "../../components/Loader";
const LevelElegible = () => {
  // State for mobile filter visibility
  const [showFilter, setShowFilter] = useState(false);



  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [copiedWallet, setCopiedWallet] = useState(null);

  const { token, fetchToken } = useToken();

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const rowsPerPage = process.env.REACT_ROW_PER_PAGE || 100;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const formatBalance = (balance) => balance ? parseFloat(balance).toLocaleString() : "";

  // Format DateTime
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
      // second: "2-digit",
      // hour12: true,
    });
  };


  // Fetch Wallet Statement
  const fetchLevelIncomeElegible = useCallback(
    async (page) => {
      setLoading(true);
      try {
        // Make Sure We Have Token
        let currentToken = token || (await fetchToken());
        if (!currentToken) return;
        const loginToken = localStorage.getItem("LoginToken") || currentToken;
        const response = await LevelIncomeElegible(
          currentToken,
          loginToken
        );
        if (response.status) {
          const dataList = response.DataList || [];
          setTableData(dataList);
          setTotalRecords(response.TotalRecords || dataList.length);
        } else {
          setTableData([]);
          setTotalRecords(0);
        }
      }
      catch (error) {
        setTableData([]);
        setTotalRecords(0);
      }
      finally {
        setLoading(false);
      }
    },
    [token, fetchToken]
  );


  // Initial Load & Whenever Page Changes
  useEffect(() => {
    fetchLevelIncomeElegible(currentPage);
  }, [fetchLevelIncomeElegible, currentPage]);



  return (

    <div className="buyshheikh-page">
      <div className="pageTitle">Weekly Bonus Eligible        {/* Mobile Filter Button */}
      </div>
  




          {/* Table */}
     <div className="required-cards-wrapper">
  {loading ? (
    <div className="center-loader">
      <Loader />
    </div>
  ) : tableData.length ? (
    tableData.map((row, index) => (
      <div className="required-card" key={index}>

        {/* HEADER */}
        <div className="required-card-header">
          <div className="paid-income">
            <span>Paid Income</span>
            <b>${row.PAIDINCOME}</b>
          </div>

          <div className={`status-pill ${row.STATUS?.toLowerCase()}`}>
            <span className="status-dot"></span>
            {row.STATUS}
          </div>
        </div>

        {/* REQUIRED LEG BUSINESS */}
        <div className="section">
          <h4>Required Leg Business</h4>
          <div className="grid">
            <div className="info-row">
              <span>1st Leg</span>
              <b>${row.REQURIEDISTLEGBUSINESS}</b>
            </div>
            <div className="info-row">
              <span>2nd Leg</span>
              <b>${row.REQURIED2NDLEGBUSINESS}</b>
            </div>
            <div className="info-row">
              <span>3rd Leg</span>
              <b>${row.REQURIED3RDLEGBUSINESS}</b>
            </div>
          </div>
        </div>

        {/* LEG BUSINESS */}
        <div className="section">
          <h4>Leg Business</h4>
          <div className="grid">
            <div className="info-row">
              <span>1st Leg</span>
              <b>${row.FIRSTLEGBUSINESS}</b>
            </div>
            <div className="info-row">
              <span>2nd Leg</span>
              <b>${row.SECONDLEGBUSINESS}</b>
            </div>
            <div className="info-row">
              <span>3rd Leg</span>
              <b>${row.THIRDLEGBUSINES}</b>
            </div>
          </div>
        </div>

        {/* REMAINING LEG BUSINESS */}
        <div className="section">
          <h4>Remaining Leg Business</h4>
          <div className="grid">
            <div className="info-row warning">
              <span>1st Leg</span>
              <b>${row.REMAININGISTLEGBUSINESS}</b>
            </div>
            <div className="info-row warning">
              <span>2nd Leg</span>
              <b>${row.REMAINING2NDLEGBUSINESS}</b>
            </div>
            <div className="info-row warning">
              <span>3rd Leg</span>
              <b>${row.REMAINING3RDLEGBUSINES}</b>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="required-card-footer">
          <div className="Achieved-date">
            <span>Achieved Date</span>
            <b>{row.ACHIVEDDATE}</b>
          </div>
          <div className="paid-week">
            <span>Paid Week</span>
            <b>{row.PAIDWEEK}</b>
          </div>
        </div>

      </div>
    ))
  ) : (
    <div className="no-data">No records found</div>
  )}
</div>




      
    </div>

  );
};

export default LevelElegible;


